import * as React from 'react';

import CloseIcon from '@/assets/icons/CloseIcon';
import NewsArchiveCtx from '@/context/newsArchiveCtx';

type SelectedFilterProps = {
    value: any;
};

const SelectedFilter = (props: SelectedFilterProps) => {
    const newsArchiveCtx = React.useContext(NewsArchiveCtx);

    const { clearFilter } = newsArchiveCtx;

    const { value } = props;

    return (
        <>
            {value.name ? (
                <div className="flex items-center gap-0 text-primary cursor-pointer">
                    <span className="block uppercase text-inherit font-light text-[14px]">{value.name}</span>
                    <span onClick={() => clearFilter(value)}>
                        <CloseIcon
                            className="text-primary ml-2 hover:text-black aria-hidden=true cursor-pointer ml-2"
                            style={'primary'}
                            width={10}
                            height={10}
                        />
                    </span>
                </div>
            ) : null}
        </>
    );
};

export default SelectedFilter;
